/**
 * Created by hernanherreros on 2019-05-30
 */

import * as React from 'react'
import { Col as AntCol } from 'antd'
import styled from 'styled-components'
import { space, SpaceProps } from 'styled-system'

interface Props {
  textAlign?: 'left' | 'center' | 'right'
}

const Col = styled(AntCol)<SpaceProps & Props & any>`
  text-align: ${({ textAlign }) => textAlign};
  
  * {
    text-align: ${({ textAlign }) => textAlign};
  }
  
  @media screen and (max-width: 768px) {
    text-align: left;
    
    * {
      text-align: left;
    }
  }
  
  ${space}
`

Col.defaultProps = {
  span: 24,
  textAlign: 'left'
}

export default Col